import { findOwnershipConfigIssues } from '../utils/bookingUtils';

// Admin-facing warning banner for a broken Shared Ownership setup (Config ->
// System -> "Shared Ownership").
//
// With that switch on, a court with no owner — or an owner with no QR code —
// is a court no guest can pay for. The guest-side failure is a polite dead
// end ("please contact us"), which tells the club nothing, so the same
// misconfiguration is surfaced loudly on the screens an admin actually looks
// at: the booking screen and the config screen.
//
// Renders NOTHING when shared ownership is off, or when the setup is
// complete — findOwnershipConfigIssues returns [] in both cases — so this is
// invisible to every club that doesn't use the feature.
//
// @param {object} config - app config (or AdminConfig's in-progress formData)
// @param {string} [context] - 'config' drops the "go to Config" wording,
//                             since the reader is already there.
function OwnershipWarningBanner({ config, context = 'booking' }) {
  const issues = findOwnershipConfigIssues(config);
  if (issues.length === 0) return null;

  return (
    <div
      role="alert"
      style={{
        display: 'flex', alignItems: 'flex-start', gap: '0.6rem',
        background: 'rgba(214, 137, 16, 0.10)',
        border: '1px solid rgba(214, 137, 16, 0.45)',
        borderRadius: '10px',
        padding: '0.7rem 0.85rem',
        marginBottom: '0.9rem',
      }}
    >
      <span aria-hidden="true" style={{ fontSize: '1rem', lineHeight: 1.3 }}>⚠️</span>
      <div style={{ minWidth: 0 }}>
        <p style={{ margin: 0, fontWeight: 700, fontSize: '0.84rem', color: '#8a5a06' }}>
          Shared Ownership needs attention
        </p>
        <ul style={{ margin: '0.3rem 0 0', paddingLeft: '1.1rem', fontSize: '0.79rem', lineHeight: 1.5, color: '#8a5a06' }}>
          {issues.map(issue => (
            <li key={issue.code} style={{ overflowWrap: 'anywhere' }}>
              {/* On the config screen the "→ Config → ..." breadcrumbs in
                  each message are noise — the admin is already in there. */}
              {context === 'config' ? issue.message.replace(/\s*(?:in|In) Config → [^.]+\./g, '') : issue.message}
            </li>
          ))}
        </ul>
        <p style={{ margin: '0.4rem 0 0', fontSize: '0.75rem', opacity: 0.85, color: '#8a5a06' }}>
          Guests are shown a &quot;please contact us&quot; message instead of being able to book these courts.
        </p>
      </div>
    </div>
  );
}

export default OwnershipWarningBanner;
